import { XCircle, CheckCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ProblemSolutionSection = () => {
  const problems = [
    "Pagás marketing y no sabés a dónde va tu dinero",
    "Tenés diseñador por un lado, pauta por otro, y nadie conecta nada",
    "Tu contenido se ve bien, pero no genera ventas",
    "Cada mes empezás de cero sin una estrategia clara",
  ];

  const solutions = [
    "Un solo equipo que conecta todo: pauta, contenido, diseño y web",
    "Estrategia clara con objetivos medibles desde el día uno",
    "Contenido diseñado para vender, no solo para verse bonito",
    "Optimización continua basada en datos reales",
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary">
            ¿Te suena familiar?
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Problems */}
          <Reveal delay={1}>
            <div className="p-6 sm:p-8 rounded-2xl bg-destructive/5 border border-destructive/10 hover:border-accent transition-colors">
              <h3 className="text-lg sm:text-xl font-bold text-primary mb-6">
                Lo que vivís hoy
              </h3>
              <ul className="space-y-4">
                {problems.map((problem, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <XCircle className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base text-foreground/85">{problem}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Solutions */}
          <Reveal delay={2}>
            <div className="p-6 sm:p-8 rounded-2xl bg-primary/5 border border-primary/10 hover:border-accent transition-colors">
              <h3 className="text-lg sm:text-xl font-bold text-primary mb-6">
                Lo que pasa cuando trabajás con nosotros
              </h3>
              <ul className="space-y-4">
                {solutions.map((solution, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-sm sm:text-base text-foreground/85">{solution}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
